export enum ProgressBarSelectionMode {
    INTERNAL,
    EXTERNAL
}
